import Joi from "joi";
import sanitizeHtml from 'sanitize-html';

export class SecurityService {
    static _instance: SecurityService;

    static namePattern = /^[^<>\\&%{}]+$/; // regex to match any string that does not contain < > \ & % { }

    static cqlPattern = /^[^\\{}]+$/; // regex to match any string that does not contain \ { }

    static spaceLabelsPattern = /^[^<>*!()]+$/;

    static imageURLPattern = /^(http|https):\/\/[^ "]+$/;

    static instance(): SecurityService {
        if (!this._instance) {
            this._instance = new SecurityService();
        }

        return this._instance;
    }

    static SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;
    /** A pattern that matches safe data URLs. It only matches image, video, and audio types. */
    static DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;

    public sanitizeUrl(url: string): string {
        url = String(url);
        if (url.match(SecurityService.SAFE_URL_PATTERN) || url.match(SecurityService.DATA_URL_PATTERN)) return url;

        return `unsafe:${url}`;
    }

    static isValidUrl(url: string): boolean {
        try {
            Joi.assert(url, Joi.string().uri());
            return true;
        } catch (e) {
            return false;
        }
    }

    static isValidImageUrl(url: string): boolean {
        return SecurityService.imageURLPattern.test(url);
    }

    static isValidName(nameValue: string) {
        return SecurityService.namePattern.test(nameValue);
    }

    static isSafeCql(cqlValue: string) {
        return SecurityService.cqlPattern.test(cqlValue);
    }

    public sanitizeSpaceKey(rawSpaceKey: string): string {
        return rawSpaceKey.replace(/[^A-Za-z0-9~]/gm, "");
    }

    public sanitizeFileName(fileName: string): string {
        return fileName.replace(/[^a-zA-Z0-9.]/g, "_");
    }

    sanitizeHtml(rawValue: string): string {
        return sanitizeHtml(rawValue);
    }
}

export const securityService = SecurityService.instance();
